import { Component, ElementRef, EventEmitter, HostListener, Input, Output, TemplateRef, ViewChild } from '@angular/core';
import { MobileDetectionService } from '../../services/mobile-detection.service';
import { MenuItem } from 'primeng/components/common/menuitem';
import { OverlayPanel } from 'primeng/overlaypanel';
import { environment } from '../../../../environments/environment';
import { DecryptPipe, EncryptPipe } from '../../../auth/_services/encrypt-decrypt.pipe';
import { CookieService } from 'ngx-cookie-service';
import { appService } from '../../../_services/app.service';
import { NavService } from '../../../_services/NavService.service';
import { Router } from '@angular/router';
import { CommonService } from '../../../_services/common.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-main-header',
  templateUrl: './main-header.component.html',
  styleUrls: ['./main-header.component.scss']
})
export class MainHeaderComponent {
  static MainHeaderComponent: MainHeaderComponent;
  public userTypeList: any;
  userCountCookie: number;
  SelectedCompanyCIN: any;
  SelectedCompantGSTIN: any;
  SelectedCompanyPAN: any
  SelectedComapnyName: any;
  SelectedCompanyAdd: any;
  imgPath: any;
  SelectedCompantEmail: any;
  SelectedCompanyWebsite: any;
  SelectedCompanyLogo: any;
  @Output() onCloseEvent = new EventEmitter<any>();
  @Input() isMobileView: any;
  RechargeAmount: any;
  @Input() listOfField = [];
  TransactionId: any;
  Company: any;
  PaymentMethod: any;
  isFormSubmit: boolean = false;
  CompanyId: any;
  Date: any;
  @Output() modifiedValueOutput = new EventEmitter<any>();
  @ViewChild('Rechargewall') AddRecharge: TemplateRef<any>;
  modalRef: any;
  systemsettingforwallet: any;
  @Input()  Balance: any;
  static that: MainHeaderComponent;
  selectedCompany: any = 'iFreightBox Technologies LL';
  @Input() items: MenuItem[];
  @Input() IsSearchIconShow: boolean = false;
  @Output() CompanyChnage = new EventEmitter<string>();
  isMenuShow: boolean;
  searchFieldDetails: any = {
    placeholder: 'Search',
    type: 'text',
    isSearchBox: true
  };
  companyFieldDetails: any = {
    formControlName: 'companyFieldDetails',
    dataField: 'companyFieldDetails',
    placeholder: 'Select Company',
    isValueBind: true,
    isSearch: false,
  };
  WalletDropList: any = [
    { value: 'TransactionHistory', },
    { value: 'Wallet', },
  ]

  dropdownVisible = false;
  newDropdownVisible = false;
  toggleDropdown() {
    if (this.IsKyc === false) {
      this.toaster.error("Please Complete your KYC first");
    }
    else {
      this.dropdownVisible = !this.dropdownVisible;
    }
  }

  showDropdown() {
    this.dropdownVisible = true;
  }

  hideDropdown() {
    this.dropdownVisible = false;
  }

  newToggle(event: Event) {
    this.newDropdownVisible = !this.newDropdownVisible;
    event.stopPropagation();
  }

  onWalletChange(event: string): void {
    if (event === this.WalletDropList.TransactionHistory || event === this.WalletDropList.Wallet) {
      this.router.navigate(['Wallet']);
    }
  }
  Wallet: any = {
    // lable: "Basicdeatilsform.ExpenseCompany",
    //isRequired: true,
    formControlName: 'CompanyId',
    isDropdownUnique: true,
    dropdownIcon: '../../../../assets/AccountBalanceWallet.png',
    dataField: 'WalletDropList',
    isValueBind: true,
    type: 'dropdown'
    //  placeholder: "Basicdeatilsform.SelectCompany",
  };
  @Input() isDetailsPageShow: boolean = false;
  @Input() IsCompanyShow: boolean = true;
  @Input() IsSearchShow: boolean = true;
  @Input() IsNewMenuShow: boolean = true;
  @Input() ISSettingShow: boolean = true;
  @Input() totalCount: number;
  @Input() isMoreActionBtn: boolean;
  @Input() title: number;
  @Input() isFilter: boolean;
  @Input() listOfFilter: any[] = [];
  @Output() goToTable = new EventEmitter<string>();
  @Output() addBtnClick = new EventEmitter<boolean>();
  @Output() seachValueOutput = new EventEmitter<string>()
  @Output() onFilterClickOutput = new EventEmitter();
  @Output() onFilterClickApplyOutput = new EventEmitter<any[]>();
  apiUrl: any = environment.apiUrl;
  isBestUrl: any = environment.apiUrl == 'https://best.ifreightbox.net/' ? true : false;
  moreActionBtn2: any[];
  TenantId: any;
  TenantUsers: any;
  CompanyIdForCookie: any;
  UserFullName: any;
  UserEmailId: any
  EmailId: string;
  userRole: string[];
  userComanyName: string;
  editright: any;
  userId: any;
  IsKyc: any;
  hostUrl: any = environment.apiUrl;
  // hostUrl: any = "https://ximble.ifreightbox.net/";

  IsBranchDropDownShow: boolean = true;
  IsHeadMenuListShow: boolean = true;
  IsWalletShow: boolean = true;

  constructor(
    private _appService: appService,
    private encryptpipe: EncryptPipe,
    private decryptpipe: DecryptPipe,
    private cookieService: CookieService,
    private _navService: NavService,
    private router: Router,
    private commonService: CommonService,
    private modalService: NgbModal,
    private toaster: ToastrService,
    // private mobileDetectionService: MobileDetectionService
  ) {
    MainHeaderComponent.MainHeaderComponent = this;
  }
  ngOnInit() {
    this.GetUserType();
    this.initializeform();
    this.CheckKYC();
    this.GetSystemsettingwallet();
    this.BranchDropDownVisibility();
    this.HeadMenuListVisibility();
    this.editright = this.commonService.CheckHasRight('VIEW', 'WALLET_DETAILS')
    this.userId = this.decryptpipe.transform(JSON.parse(this.cookieService.get("UserId")));
    this.UserEmailId = this.decryptpipe.transform(JSON.parse(this.cookieService.get("EmailId")));
    this.UserFullName = this.decryptpipe.transform(JSON.parse(this.cookieService.get("UserFullName")));
    this.TenantId = JSON.parse(this.decryptpipe.transform(JSON.parse(this.cookieService.get("TenantId"))));
    this.EmailId = this.UserEmailId;
    this.userComanyName = JSON.parse(localStorage.getItem("userComanyName"));
    let x = this.decryptpipe.transform(JSON.parse(this.cookieService.get("SetUserRole")));
    var userRole1 = x;
    this.userRole = $.parseJSON(userRole1);
    // this.CompanyId = JSON.parse(localStorage.getItem("ChnageCompnayId")).Id;
    // this.userId = this.decryptpipe.transform(
    //   JSON.parse(this.cookieService.get("UserId"))
    // );
    this.moreActionBtn2 = [
      {
        label: 'User: ' + this.UserFullName,
        icon: 'pi pi-user',
        command: () => {
          // Add any action if required
        }
      },
      // {
      //   label: 'Email: ' + this.EmailId,
      //   icon: 'pi pi-envelope',
      //   command: () => {
      //     // Add any action if required
      //   }
      // },
      // {
      //   label: 'Role: ' + this.userRole[0],
      //   icon: 'pi pi-users',
      //   command: () => {
      //     // Add any action if required
      //   }
      // },
      {
        label: 'Logout',
        icon: 'pi pi-power-off',
        routerLink: ['/logout-new']
      }
    ];
    this.items = [
      {
        label: 'File',
        icon: 'pi pi-pw pi-file',
        items: [{
          label: 'New',
          icon: 'pi pi-fw pi-plus',
          items: [
            { label: 'User', icon: 'pi pi-fw pi-user-plus' },
            { label: 'Filter', icon: 'pi pi-fw pi-filter' }
          ]
        },
        { label: 'Open', icon: 'pi pi-fw pi-external-link' },
        { separator: true },
        { label: 'Quit', icon: 'pi pi-fw pi-times' }
        ]
      },
      {
        label: 'Edit',
        icon: 'pi pi-fw pi-pencil',
        items: [
          { label: 'Delete', icon: 'pi pi-fw pi-trash' },
          { label: 'Refresh', icon: 'pi pi-fw pi-refresh' }
        ]
      },
      {
        label: 'Help',
        icon: 'pi pi-fw pi-question',
        items: [
          {
            label: 'Contents',
            icon: 'pi pi-pi pi-bars'
          },
          {
            label: 'Search',
            icon: 'pi pi-pi pi-search',
            items: [
              {
                label: 'Text',
                items: [
                  {
                    label: 'Workspace'
                  }
                ]
              },
              {
                label: 'User',
                icon: 'pi pi-fw pi-file',
              }
            ]
          }
        ]
      },
      {
        label: 'Actions',
        icon: 'pi pi-fw pi-cog',
        items: [
          {
            label: 'Edit',
            icon: 'pi pi-fw pi-pencil',
            items: [
              { label: 'Save', icon: 'pi pi-fw pi-save' },
              { label: 'Update', icon: 'pi pi-fw pi-save' },
            ]
          },
          {
            label: 'Other',
            icon: 'pi pi-fw pi-tags',
            items: [
              { label: 'Delete', icon: 'pi pi-fw pi-minus' }
            ]
          }
        ]
      }
    ];
    this.getCompanyList();
    this.userCountCookie = JSON.parse(
      this.decryptpipe.transform(JSON.parse(this.cookieService.get("UserCount")))
    );
    this.Wallet.dropdownList = this.WalletDropList;
    console.log(this.Wallet)

    setTimeout(() => {
      this.GetLoginCompanyData();
      this.getWalletCount();
    }, 1000);

    this.imgPath = environment.apiUrl + this.SelectedCompanyLogo;
    console.log(this.imgPath, 'imgpath selected company')

  }


  BranchDropDownVisibility() {
    this._appService
      .GetById("Common", "GetSystemSettingByName", "BranchDropDownVisibility")
      .subscribe(
        (response) => {
          if (response === '0') {
            this.IsBranchDropDownShow = false;
          } else {
            this.IsBranchDropDownShow = true;
          }
        },
        (err) => {
          this.toaster.error(
            "Error occurred while fetching Status data !",
            "error"
          );
        }
      );
  }

  HeadMenuListVisibility() {
    this._appService
      .GetById("Common", "GetSystemSettingByName", "HeadMenuListVisibility")
      .subscribe(
        (response) => {
          if (response === '0') {
            this.IsHeadMenuListShow = false;
          } else {
            this.IsHeadMenuListShow = true;
          }
        },
        (err) => {
          this.toaster.error(
            "Error occurred while fetching Status data !",
            "error"
          );
        }
      );
  }

  save(severity: string) {
  }

  update() {
  }

  delete() {
  }

  onBackArrowCLick() {
    this.goToTable.emit();
  }

  onAddClick() {
    this.addBtnClick.emit();
  }

  onSearch(value: any) {
    this.seachValueOutput.emit(value);
  }
  // onFilterClick(value) {
  //   this.isFilterShow = value;
  //   if (value) {
  //     this.onFilterClickOutput.emit();
  //   }
  // }

  // onFilterApply(filterList: any[]) {
  //   this.onFilterClickApplyOutput.emit(filterList);
  // }
  onSelectChange(event: any) {
    for (const item of this.companyFieldDetails.dropdownList) {
      if (item.Id == event) {
        this.CompanyIdForCookie = item;
        this.ChnageDefultCompany();
      }
    }
  }

  // UserEmailId: any;
  // EmailId: any;
  // UserFullName: any;
  // userComanyName: any;
  // userRole: any;
  // clickUserProfile() {
  //   this.UserEmailId = this.decryptpipe.transform(JSON.parse(this.cookieService.get("EmailId")));
  //   this.EmailId = this.UserEmailId;
  //   this.UserFullName = this.decryptpipe.transform(JSON.parse(this.cookieService.get("UserFullName")));
  //   this.userComanyName = JSON.parse(localStorage.getItem("userComanyName"));
  //   let x = this.decryptpipe.transform(JSON.parse(this.cookieService.get("SetUserRole")));
  //   var userRole1 = x;
  //   this.userRole = $.parseJSON(userRole1);
  // }

  preventMenuOpen(event: MouseEvent) {
    event.stopPropagation(); // Prevent the click event from propagating
  }

  getCompanyList() {
    this._appService.GetById("Company", "GetUserCompany", this.TenantId).subscribe((response) => {
      this.TenantUsers = response.data; //FOR DROPDOWN
      this.TenantUsers.map(x => {
        x.name = x.Label;
        x.value = x.Id;
      })
      this.companyFieldDetails.dropdownList = this.TenantUsers;

      setTimeout(() => {
        this.TenantUsers.forEach((element) => {
          if (element.DefaultCompanyId == element.Id) {
            this.CompanyIdForCookie = element;
            $("#UserCompany").val(element.Id);
          }
        });

        if (localStorage.getItem("ChnageCompnayId") == "undefined") {
          localStorage.setItem("ChnageCompnayId", JSON.stringify(this.CompanyIdForCookie));
        }

        if (
          JSON.parse(localStorage.getItem("ChnageCompnayId")) == null &&
          JSON.parse(localStorage.getItem("ChnageCompnayId")) == undefined
        ) {
          localStorage.setItem("ChnageCompnayId", JSON.stringify(this.CompanyIdForCookie));
        } else {
          this.TenantUsers.forEach((element) => {
            if (JSON.parse(localStorage.getItem("ChnageCompnayId")).Id != undefined) {
              if (JSON.parse(localStorage.getItem("ChnageCompnayId")).Id == element.Id) {
                this.CompanyIdForCookie = element;
              }
            }
          });
        }
        this.ChnageDefultCompany();
      }, 10);
    });
  }

  ChnageDefultCompany() {
    localStorage.setItem("ChnageCompnayId", JSON.stringify(this.CompanyIdForCookie));
    this.CompanyChnage.emit(this.CompanyIdForCookie);
    this._navService.changeNav(this.CompanyIdForCookie);
    this.selectedCompany = this.CompanyIdForCookie.Id;
    console.log('this.CompanyIdForCookie', this.CompanyIdForCookie);
  }
  getWalletCount() {
    this.CompanyId = JSON.parse(localStorage.getItem("ChnageCompnayId")).Id;
    this.userId = this.decryptpipe.transform(
      JSON.parse(this.cookieService.get("UserId"))
    );
    this._appService.GetByTwoParam('OrdersByVehicle', 'GetWalletCount', this.CompanyId, this.userId).subscribe(
      (response) => {
        console.log(response)
        if (response.length > 0) {

          this.Balance = response[0].Balance

        }

      },
      (err) => {
        console.log(err)

      }
    )
  }
  Recharge() {
    this.modalRef = this.modalService.open(this.AddRecharge);
  }
  initializeform() {
    this.RechargeAmount = {
      lable: "Recharge Amount",
      placeholder: "Enter Recharge Amount",
      dataField: 'Amount',
      formControlName: 'Amount',
      type: 'number',
      isRequired: true,
    };
    this.TransactionId = {
      lable: "TransactionId",
      placeholder: "Enter TransactionId",
      dataField: 'TransactionId',
      formControlName: 'TransactionId',
      type: 'text',
    };
    this.Company = {
      lable: "Company",
      placeholder: "Select Company",
      dataField: 'NetWorktypeId',
      formControlName: 'NetWorktypeId',
      isValueBind: true
    };
    this.Date = {
      lable: 'Date',
      dataField: 'Date',
      formControlName: 'Date',
      placeholder: 'Date'
    };
    this.PaymentMethod = {
      lable: "PaymentMethod",
      placeholder: "Select PaymentMethod",
      dataField: 'PaymentMethod',
      formControlName: 'PaymentMethod',
      isValueBind: true
    };
  }
  GetLoginCompanyData() {
    this.CompanyId = JSON.parse(localStorage.getItem("ChnageCompnayId")).Id;
    this.SelectedComapnyName = JSON.parse(localStorage.getItem("ChnageCompnayId")).SelectedComapnyName;
    this.SelectedCompanyAdd = JSON.parse(localStorage.getItem("ChnageCompnayId")).SelectedCompanyAdd;
    this.SelectedCompanyCIN = JSON.parse(localStorage.getItem("ChnageCompnayId")).SelectedCompanyCIN;
    this.SelectedCompantGSTIN = JSON.parse(localStorage.getItem("ChnageCompnayId")).SelectedCompantGSTIN;
    this.SelectedCompanyLogo = JSON.parse(localStorage.getItem("ChnageCompnayId")).CompanyLogoPath;
    this.SelectedCompanyPAN = JSON.parse(localStorage.getItem("ChnageCompnayId")).SelectedCompanyPAN;
    this.SelectedCompantEmail = JSON.parse(localStorage.getItem("ChnageCompnayId")).SelectedComapnyEmail;
    this.SelectedCompanyWebsite = JSON.parse(localStorage.getItem("ChnageCompnayId")).Website;
    //$(".LoginCompanyLogo").attr("src", environment.apiUrl + this.SelectedCompanyLogo);

  }
  private GetUserType() {
    this._appService.Get("User", "GetNetworkType").subscribe((response) => {
      this.userTypeList = response;
      // MainHeaderComponent.MainHeaderComponent.refreshUserRoles();
    });
  }
  // refreshUserRoles() {
  //   setTimeout(function () {
  //     (<any>$("#userRolesHeader")).selectpicker("refresh");
  //     (<any>$("#userTypeIdHeader")).selectpicker("refresh");
  //   });
  // }


  @HostListener('document:click', ['$event'])
  handleClick(event: Event) {
    const target = event.target as HTMLElement;
    const dropdown = document.querySelector('.dropdown-menu1');

    if (this.newDropdownVisible && dropdown && !dropdown.contains(target)) {
      this.newDropdownVisible = false;
    }
  }

  GetSystemsettingwallet() {
    this._appService
      .GetById("Common", "GetSystemSettingByName", "Wallet")
      .subscribe(
        (response) => {
          // Check the response value and convert it to a string for safe comparison
          const walletVisibility = response.trim(); // trim to remove any extra spaces

          // If response is '0', hide the wallet, otherwise show it
          if (walletVisibility === '0') {
            this.IsWalletShow = false;  // Hide the wallet
          } else {
            this.IsWalletShow = true;   // Show the wallet
          }
        },
        (err) => {
          console.error("Error occurred while fetching wallet status", err);
        }
      );
  }


  CheckKYC() {
    let Userid = this.userId = this.decryptpipe.transform(
      JSON.parse(this.cookieService.get("UserId"))
    );
    this._appService
      .GetById("OrdersByVehicle", "checkTransporter", Userid).subscribe((response) => {
        this.IsKyc = response[0].IsKyc;
        // console.log("Newhome KYC Flag", this.IsKyc);
      }),
      (error) => {
        console.log(error);
      }
  }
}
